const SESSION_KEY = "ph_session_id";
const DISTINCT_KEY = "ph_distinct_id";

let handoffConsumedThisBoot = false;

export function wasAnalyticsHandoffConsumed(): boolean {
  return handoffConsumedThisBoot;
}

export function appendAnalyticsHandoff(
  url: string,
  ids: { sessionId: string; distinctId: string },
): string {
  if (!ids.sessionId?.trim() || !ids.distinctId?.trim()) return url;
  try {
    const target = new URL(url, window.location.origin);
    const params = new URLSearchParams(target.hash.replace(/^#/, ""));
    params.set(SESSION_KEY, ids.sessionId);
    params.set(DISTINCT_KEY, ids.distinctId);
    target.hash = params.toString();
    return target.toString();
  } catch {
    return url;
  }
}

export function consumeAnalyticsHandoff(): {
  sessionId: string;
  distinctId: string;
} | null {
  try {
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sessionId = params.get(SESSION_KEY)?.trim();
    const distinctId = params.get(DISTINCT_KEY)?.trim();
    if (!sessionId || !distinctId) return null;
    // PostHog session IDs are UUID v7-ish
    if (!/^[0-9a-f-]{20,}$/i.test(sessionId)) return null;

    params.delete(SESSION_KEY);
    params.delete(DISTINCT_KEY);
    const remaining = params.toString();
    const next = `${window.location.pathname}${window.location.search}${
      remaining ? `#${remaining}` : ""
    }`;
    window.history.replaceState(null, "", next);

    handoffConsumedThisBoot = true;
    return { sessionId, distinctId };
  } catch {
    return null;
  }
}
